import React from 'react';
import { DialogOptionsContents } from './style';
import {
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  IconButton,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
} from '@mui/material';

import { BrowserSettingsLinks } from '../../BrowserSettingsLinks';
import { SupportEmailMessage } from '../../SupportEmailMessage';
// ICONS
import TimeLineIcon from '../../Icons/system/TimeLine';
import ErrorWarningLineIcon from '../../Icons/system/ErrorWarningLine';
import FileDamageLineIcon from '../../Icons/document/FileDamageLine';
import CameraOffLineIcon from '../../Icons/media/CameraOffLine';
import QuillPenLineIcon from '../../Icons/design/QuillPenLine';
import EyeCloseLineIcon from '../../Icons/system/EyeCloseLine';
import EyeLineIcon from '../../Icons/system/EyeLine';
import MailSendLineIcon from '../../Icons/business/MailSendLine';
import CheckboxCircleLine from '../../Icons/system/CheckboxCircleLine';
import CheckboxBlankCircleLineIcon from '../../Icons/system/CheckboxBlankCircleLine';
import FileDownloadLineIcon from '../../Icons/document/FileDownloadLine';
import CheckLineIcon from '../../Icons/system/CheckLine';
import CloseLineIcon from '../../Icons/system/CloseLine';
import Message2LineIcon from '../../Icons/communication/Message2Line';
import InformationLineIcon from '../../Icons/system/InformationLine';
import { VerifyOtp } from '../../../VerifyOtp/VerifyOtp';

export const dialogOptions = ({
  password,
  visibility,
  setPassword,
  setVisibility,
  passwordRef,
  payload = {},
  form,
  theme,
  classes,
}) => {
  return {
    cameraBlocked: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <CameraOffLineIcon
              fill={theme.palette.error.main}
              width={35}
              height={35}
            />

            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Cámara bloqueada
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Por favor busca en la configuración de tu navegador como
              restablecer los permisos de la cámara,{' '}
              <strong>de otra manera no podrás continuar.</strong>
            </DialogContentText>
          </DialogContent>
          <BrowserSettingsLinks />
          <SupportEmailMessage />
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: '',
        cancel: 'Cerrar',
      },
    }),
    emailVerificationTokenExpired: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <TimeLineIcon
              fill={theme.palette.error.main}
              width={35}
              height={35}
            />

            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Tu token ha expirado
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <strong>
                El tiempo para realizar tu verificación de cuenta ha expirado
              </strong>
              . Te redireccionaremos a la pantalla de ingreso para que vuelvas a
              realizar el proceso
            </DialogContentText>
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Inicio',
        cancel: '',
      },
    }),
    emailVerificationTokenMismatch: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <CloseLineIcon
              fill={theme.palette.error.main}
              width={35}
              height={35}
            />

            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Token incorrecto
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              El token de tu liga no es valido. Te redireccionaremos a la
              pantalla de ingreso para que vuelvas a realizar el proceso
            </DialogContentText>
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Inicio',
        cancel: '',
      },
    }),
    resetTokenFailed: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <TimeLineIcon
              fill={theme.palette.text.secondary}
              width={35}
              height={35}
            />

            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Tu token ha expirado
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              El tiempo para realizar tu cambio de contraseña ha expirado. Te
              redireccionaremos a la pantalla de ingreso para que vuelvas a
              realizar el proceso
            </DialogContentText>
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Inicio',
        cancel: '',
      },
    }),
    resetPasswordSuccess: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <CheckboxCircleLine
              fill={theme.palette.text.secondary}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              ¡Se ha cambiado tu contraseña exitosamente!
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Da click en "Inicio" para regresar a la pantalla de ingreso, ahí
              deberás ingresar tu correo y tu nueva contraseña
            </DialogContentText>
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Inicio',
        cancel: '',
      },
    }),
    resetPasswordFailed: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <ErrorWarningLineIcon
              fill={theme.palette.error.main}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Lo sentimos mucho
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Hubo un error con el cambio de contraseña, favor de intentar mas
              tarde
            </DialogContentText>
          </DialogContent>
          <SupportEmailMessage />
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Inicio',
        cancel: '',
      },
    }),
    revokeSignature: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Revocar firma
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Para revocar tu firma por favor introduce la contraseña que usas
              para ingresar a la plataforma.
              <br />
              <br />
              <strong>
                {' '}
                Una vez revocada, deberás crear tu firma de nuevo para poder
                continuar.
              </strong>
            </DialogContentText>
            <br />
            <TextField
              variant="outlined"
              ref={passwordRef}
              required
              fullWidth
              error={passwordRef?.current?.error}
              name="password"
              label="Contraseña"
              type={visibility ? 'text' : 'password'}
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <IconButton onClick={() => setVisibility(!visibility)}>
                    {visibility ? <EyeLineIcon /> : <EyeCloseLineIcon />}
                  </IconButton>
                ),
              }}
            />
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Revocar',
        cancel: 'Cancelar',
      },
      img: '',
    }),
    emailOtpVerificationSent: () => {
      return {
        contents: (
          <DialogOptionsContents>
            <DialogTitle id="alert-dialog-title">
              <MailSendLineIcon
                fill={theme.palette.text.secondary}
                width={35}
                height={35}
              />
              <Typography
                sx={{ fontWeight: 'bold' }}
                variant="h6"
                component="div"
              >
                ¡Verifica tu correo!
              </Typography>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Hemos enviado un <strong>código de único uso</strong> vía correo
                electrónico a:
                <br />
                <br />
                <strong
                  style={{
                    textTransform: 'uppercase',
                    color: theme.palette.text.primary,
                  }}
                >
                  {payload?.email || 'developer@sora.mx'}
                </strong>
              </DialogContentText>
            </DialogContent>
            <VerifyOtp
              overrideSubmit={payload?.overrideSubmit || console.log}
              noLogo
              noBack
              noDesc
              noMargin
              noButton
            />
          </DialogOptionsContents>
        ),
        buttons: {
          confirm: '',
          cancel: 'Cerrar',
        },
      };
    },
    emailLinkVerificationSent: () => {
      return {
        contents: (
          <DialogOptionsContents>
            <DialogTitle id="alert-dialog-title">
              <MailSendLineIcon
                fill={theme.palette.text.secondary}
                width={35}
                height={35}
              />
              <Typography
                sx={{ fontWeight: 'bold' }}
                variant="h6"
                component="div"
              >
                ¡Verifica tu correo!
              </Typography>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Hemos enviado un <strong>link de único uso</strong> vía correo
                electrónico a:
                <br />
                <br />
                <strong
                  style={{
                    textTransform: 'uppercase',
                    color: theme.palette.text.primary,
                  }}
                >
                  {payload?.email || 'developer@sora.mx'}
                </strong>
                <br />
                <br />
                Ingresa al link que te enviamos para verificar tu correo
                <br />
                <br />
                <strong>Tendrás que verificar tu correo en 24 horas</strong>. De
                lo contrario será necesario que vuelvas a realizar el proceso.
                <br />
                <br />
                Si no recibiste el link, revisa tu carpeta de{' '}
                <strong>spam</strong>
              </DialogContentText>
            </DialogContent>
          </DialogOptionsContents>
        ),
        buttons: {
          confirm: '',
          cancel: 'Cerrar',
        },
      };
    },
    requirePhoneOtp: () => {
      return {
        contents: (
          <DialogOptionsContents>
            <DialogTitle id="alert-dialog-title">
              <Message2LineIcon
                fill={theme.palette.text.secondary}
                width={35}
                height={35}
              />
              <Typography
                sx={{ fontWeight: 'bold' }}
                variant="h6"
                component="div"
              >
                ¡Verifica tu teléfono!
              </Typography>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Hemos enviado un <strong>código de único uso</strong> vía
                mesnaje de texto a:
                <br />
                <br />
                <strong
                  style={{
                    textTransform: 'uppercase',
                    color: theme.palette.text.primary,
                  }}
                >
                  {payload?.phone || '+528117986527'}
                </strong>
              </DialogContentText>
            </DialogContent>
            <VerifyOtp
              overrideSubmit={payload?.overrideSubmit || console.log}
              noLogo
              noSendAgain
              noBack
              noDesc
              noMargin
              noButton
            />
          </DialogOptionsContents>
        ),
        buttons: {
          confirm: '',
          cancel: 'Cerrar',
        },
      };
    },
    noNetworkConnection: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <ErrorWarningLineIcon
              fill={theme.palette.error.main}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Problemas de conexión
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Detectamos un problema con tu <strong>conexión a internet</strong>
              , por favor verifica que tu conexión esté <strong>activa</strong>
            </DialogContentText>
          </DialogContent>
          <SupportEmailMessage />
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Continuar',
        cancel: '',
      },
    }),
    finishRedirect: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <CheckLineIcon
              fill={theme.palette.text.secondary}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Te redireccionaremos de vuelta a tu portal.
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <strong
                style={{
                  textTransform: 'uppercase',
                  color: theme.palette.text.primary,
                }}
              >
                {payload?.redirect?.split('//')[1]}
              </strong>
              <br />
              <br />
              <strong>
                {' '}
                ¡No olvides revisar si tienes documentos por firmar!
              </strong>
            </DialogContentText>
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Finalizar',
        cancel: '',
      },
    }),
    filesUploadSuccess: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <CheckboxCircleLine
              fill={theme.palette.text.secondary}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              ¡Carga exitosa!
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Se ha cargado exitosamente tus documentos{' '}
            </DialogContentText>
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Ir a firmar',
        cancel: 'Cerrar',
      },
    }),
    encryptedFileError: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <FileDamageLineIcon
              fill={theme.palette.error.main}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Documento inválido
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Detectamos un problema con el documento <br />
              <br />
              <strong style={{ fontSize: '1.2rem' }}>
                {payload.fileName}{' '}
              </strong>
              <br />
              <br />
              Es posible que el documento esté <strong>encriptado</strong>
              <br /> Por favor verifica que tu documento esté{' '}
              <strong>libre de hacer modificaciones</strong>
            </DialogContentText>
          </DialogContent>
          <SupportEmailMessage />
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Continuar',
        cancel: '',
      },
    }),
    confirmEditExtAPI: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <QuillPenLineIcon
              fill={theme.palette.text.secondary}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Confirmación de API
            </Typography>
          </DialogTitle>
          <DialogContent
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <DialogContentText id="alert-dialog-description">
              {' '}
              ¿Estás seguro de estos datos?
            </DialogContentText>
            <br />
            {Object.keys(payload?.apiData || {}).map((key) => (
              <Typography key={key} variant="body1">
                {key}: <b>{payload?.apiData?.[key]}</b>
              </Typography>
            ))}
            {/* <Typography variant="h6">{payload.origin}</Typography> */}
            <br />
            <DialogContentText id="alert-dialog-description">
              {' '}
              ¿Con estos permisos?
            </DialogContentText>
            <List>
              {payload?.permissions?.map((permission) => (
                <ListItem key={permission.title} role="listitem">
                  <ListItemIcon>
                    {permission.hasAccess ? (
                      <CheckboxCircleLine fill={theme.palette.text.secondary} />
                    ) : (
                      <CheckboxBlankCircleLineIcon
                        fill={theme.palette.text.secondary}
                      />
                    )}
                  </ListItemIcon>
                  <ListItemText
                    style={{
                      color:
                        !permission.hasAccess && theme.palette.text.secondary,
                    }}
                    primary={permission.title}
                  />
                </ListItem>
              ))}
            </List>
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Confirmar',
        cancel: 'Cerrar',
      },
    }),
    downloadExtAPIFile: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <FileDownloadLineIcon
              fill={theme.palette.text.secondary}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              ¿Deseas descargar el archivo token?
            </Typography>
          </DialogTitle>
          <DialogContent
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Typography variant="h6">{payload?.fileName}</Typography>
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Descargar',
        cancel: 'Cerrar',
      },
    }),
    confirmEditCron: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <QuillPenLineIcon
              fill={theme.palette.text.secondary}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Cronjob edition
            </Typography>
          </DialogTitle>
          <DialogContent
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <DialogContentText id="alert-dialog-description">
              {' '}
              ¿Are your sure of this changes?
            </DialogContentText>
            <br />
            <Typography variant="subtitle1">
              Current name: <strong>{payload?.currentName}</strong>
            </Typography>
            <Typography variant="subtitle1">
              Current time: <strong>{payload?.currentHumanCronExp}</strong>
            </Typography>
            <br />
            {Boolean(payload?.newCronData?.humanCronExp) && (
              <div style={{ textAlign: 'center' }}>
                <Typography variant="subtitle1" color="error">
                  New running time
                </Typography>
                <Typography variant="h6">
                  <strong>{payload?.newCronData?.humanCronExp}</strong>
                </Typography>
              </div>
            )}
            <br />
            <Typography variant="h6">Changes details</Typography>
            <List>
              {Object.entries(payload?.newCronData || {})
                .filter((entry) => entry[0] !== 'humanCronExp')
                .map(([key, value]) => {
                  return (
                    <ListItem key={key} role="listitem">
                      <ListItemText
                        primary={
                          <Typography variant="body1">
                            {key} = <strong>{`${value}`}</strong>
                          </Typography>
                        }
                      />
                    </ListItem>
                  );
                })}
            </List>
            <br />
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Confirm',
        cancel: 'Close',
      },
    }),
    maxDocsSelected: () => ({
      contents: (
        <DialogOptionsContents>
          <DialogTitle id="alert-dialog-title">
            <InformationLineIcon
              fill={theme.palette.text.secondary}
              width={35}
              height={35}
            />
            <Typography
              sx={{ fontWeight: 'bold' }}
              variant="h6"
              component="div"
            >
              Número máximo de documentos seleccionados
            </Typography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Si deseas seleccionar más elementos cambia el número de{' '}
              <strong>documentos por página</strong>. Esta opción se encuentra
              en la parte inferior de la tabla.
              <br />
              <br />
            </DialogContentText>
          </DialogContent>
        </DialogOptionsContents>
      ),
      buttons: {
        confirm: 'Entendido',
        cancel: '',
      },
    }),
  };
};
